export default __webpack_public_path__ + "static/media/performancesforobjects_titleResized.622094ce.png";